export default __webpack_public_path__ + "static/media/header_logo_black.66340291.svg";